/**
 * Angular imports.
 */
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, OnInit,ChangeDetectorRef } from '@angular/core';

/**
 * constant imports
 */
import { TEMPLATE_TYPE, CREATE_STORY_TYPES } from 'src/app/constants/app.constants';

/**
 * Creation options for the mobile web.
 */
@Component({
  selector: 'app-creation-options',
  templateUrl: './creation-options.component.html',
  styleUrls: ['./creation-options.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CreationOptionsComponent implements OnInit {

  /**
   * Emit the actions for the available options.
   */
  @Output() emitDoAction: EventEmitter<number> = new EventEmitter();

  /**
   * Available options for the creation.
   */
  @Input() optionsList = [];
  /**
   * background codes
   */
  @Input() backGroundCodes;
  /**
   * emit the select color
   */
  @Output() emitBackGroundChange: EventEmitter<any> = new EventEmitter();
  /**
   * selected background code
   */
  public selectedCode = 0;
  /**
   * template type 
   */
  @Input() customType;
  /**
   * story type
   */
  @Input() storyType;
  /**
   * current select 
   */
  public backGroundGradient: string;
  /**
   * story type constant
   */
  public Story_Type  = CREATE_STORY_TYPES;

  /**
   * Emit the actions for the available options.
   */
  doAction(action: number): void {
    this.emitDoAction.emit(action);
  }
  constructor(private chg: ChangeDetectorRef) {
  }

  /**
   * on it componenets
   * 
   */
  ngOnInit(): void {
    if (this.customType === TEMPLATE_TYPE.BACKGROUND && this.storyType != this.Story_Type.TEMPLATE) {
      this.backGroundGradient = this.backGroundCodes[this.selectedCode]?.gradient;
      this.emitBackGroundChange.emit(this.backGroundCodes[this.selectedCode]);
      this.chg.markForCheck();
    }
  }
  changeBackGroundColour(): void {
    this.selectedCode = this.selectedCode == this.backGroundCodes?.length-1 ? 0 : this.selectedCode+1;
    this.backGroundGradient = this.backGroundCodes[this.selectedCode]?.gradient;
    this.emitBackGroundChange.emit(this.backGroundCodes[this.selectedCode]);
  }

}
